import { useEffect, useRef } from 'react';
import { Container, Typography } from '@mui/material';
import Countdown, { zeroPad } from 'react-countdown';

const CountDown = ({ expirationDate, onFinish }) => {
  const finishedRef = useRef(false);
  const mountedCheckRef = useRef(false);

  // 1) Si ya expiró al montar, ejecutar onFinish
  useEffect(() => {
    if (!expirationDate) return;
    if (mountedCheckRef.current) return;

    mountedCheckRef.current = true;

    if (Date.now() >= expirationDate && !finishedRef.current) {
      finishedRef.current = true;
      onFinish();
    }
  }, [expirationDate, onFinish]);

  // 2) Cuando Countdown termina
  const handleComplete = () => {
    if (!finishedRef.current) {
      finishedRef.current = true;
      onFinish();
    }
  };

  const renderer = ({ minutes, seconds }) => (
    <Typography
      variant="h5"
      sx={{
        fontWeight: 700,
        color: '#000',
        fontSize: { xs: '20px', sm: '30px' },
        textAlign: 'center',
      }}
    >
      {zeroPad(minutes)}:{zeroPad(seconds)}
    </Typography>
  );

  return (
    <Container
      sx={{
        pb: 0,
        pl: '0 !important',
        pr: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        ml: 0,
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          fontSize: { xs: '16px', sm: '20px' },
          mr: 0.5,
        }}
      >
        Tiempo restante
      </Typography>

      {expirationDate ? (
        <Countdown
          date={expirationDate}
          renderer={renderer}
          onComplete={handleComplete}
        />
      ) : (
        <Typography>-</Typography>
      )}
    </Container>
  );
};

export default CountDown;
